import clsx from "clsx";

import IconIncrease from "components/icons/IconIncrease";
import { FormattedNumber } from "./FormattedNumber";

interface LabeledProps extends React.HTMLAttributes<HTMLDivElement> {
  editable?: boolean;
  label: React.ReactNode;
  suffix?: string;
  text?: string | number;
  warning?: boolean;
}

const Labeled = ({
  children,
  className,
  editable,
  label,
  suffix,
  text,
  warning,
  ...rest
}: LabeledProps) => {
  const type = suffix === "%" ? "percentage" : "currency";
  return (
    <div className={clsx("labeled", className)} {...rest}>
      <small>{label}</small>
      <div className={clsx("labeled-content", warning && "warning")}>
        {(editable && children) || (
          <strong>
            <FormattedNumber
              value={text}
              type={type}
              suffix={suffix}
            ></FormattedNumber>
          </strong>
        )}
        {warning && <IconIncrease />}
      </div>
    </div>
  );
};

export default Labeled;
